<template>
  <v-container>
    <v-row justify="center" dense class="ma-0 pa-0 py-4">
      <v-col
        cols="12"
        xl="10"
        :class="$vuetify.breakpoint.smAndDown ? 'pa-0 ma-0 py-4' : ''"
      >
        <h1
          class=" font-weight-bold "
          :class="
            $vuetify.breakpoint.mdAndUp ? 'display-1 my-5' : 'text-h5 my-2'
          "
        >
          <v-icon left color="#374151">fas fa-pen-fancy</v-icon> Personal notes
          / journal
        </h1>
        <p class="body-1">
          Hi
          <span class="font-weight-bold">{{ userDetails.name }}</span> 👋 Use
          this space as a personal journal, to save ideas or just to write down
          your thoughts 💡💭
        </p>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col
        cols="12"
        xl="10"
        :class="$vuetify.breakpoint.smAndDown ? 'pa-0 ma-0 ' : ''"
      >
        <v-card
          :class="$vuetify.breakpoint.smAndDown ? 'pa-0 ma-0 ' : ''"
          :elevation="$vuetify.breakpoint.mdAndUp ? 4 : 0"
          :tile="$vuetify.breakpoint.mdAndUp ? false : true"
        >
          <v-card-title>
            <h2
              class=" font-weight-bold  pb-0 pr-0 my-2"
              :class="
                $vuetify.breakpoint.mdAndUp ? 'text-h5 pa-2' : 'text-h5 pa-1'
              "
            >
              Create a new entry
            </h2>
          </v-card-title>
          <v-card-text>
            <v-form :lazy-validation="true" ref="noteForm">
              <v-row>
                <v-col cols="12" md="8" lg="6" class="pb-0 mb-0">
                  <v-textarea
                    outlined
                    v-model="note"
                    :rules="noteRules"
                    rows="6"
                    color="primary"
                    label="What are you thinking about?"
                    auto
                  ></v-textarea>
                </v-col>
                <v-col cols="12" md="4" lg="6">
                  <v-checkbox
                    v-if="wipGoals.length > 0 || activeHabits.length > 0"
                    class="pt-0 mt-1"
                    color="primary"
                    v-model="linkToGH"
                    :label="`Link to a Goal or Habit?`"
                  ></v-checkbox>
                  <v-select
                    v-if="linkToGH"
                    outlined
                    v-model="linkedGH"
                    :items="[...wipGoals, ...activeHabits]"
                    item-text="name"
                    color="primary"
                    label="Choose one of your Goals or Habits?"
                    item-value="id"
                    :rules="linkedGHRules"
                  ></v-select>
                  <v-checkbox
                    v-if="weekData.id"
                    class="pt-0 mt-0"
                    color="primary"
                    v-model="includeInWeek"
                    :label="`Include in Week review?`"
                  ></v-checkbox>
                  <v-radio-group
                    v-if="includeInWeek"
                    v-model="inWeekAs"
                    row
                    class="mt-0 "
                    :class="$vuetify.breakpoint.mdAndUp ? 'ml-8' : 'ml-4'"
                    :rules="winLossRules"
                  >
                    <v-radio
                      label="This was a week win 🎉"
                      value="week-win"
                    ></v-radio>
                    <v-radio
                      :class="$vuetify.breakpoint.mdAndUp ? 'mt-0' : 'mt-4'"
                      label="I need to improve on this 🤔"
                      value="week-loss"
                    ></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="12" md="8" lg="6" class="text-right pt-0 mt-0">
                  <v-btn
                    :block="$vuetify.breakpoint.smAndDown"
                    @click="handleStore"
                    class="text-none text-uppercase"
                    color="primary"
                    :loading="isLoading"
                    >Save entry</v-btn
                  >
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <hr class="mx-4" />

          <div class="pa-4">
            <h3>Latest entries</h3>

            <div class="" v-if="notesByDate.length > 0">
              <v-row class="" justify="between">
                <v-col
                  cols="12"
                  md="6"
                  xl="4"
                  v-for="note in notesByDate"
                  :key="note.id"
                >
                  <v-card outlined class="body-1 ">
                    <v-card-text>
                      <blockquote class="font-italic">
                        {{ note.note }}
                      </blockquote>

                      <p class="mt-4 mb-1 text-right ">
                        <span class="font-regural font-weight-regular"
                          >Posted on
                        </span>
                        {{ formatDate(note.createdAt) }}
                      </p>
                      <div class="mt-2 font-weight-bold" v-if="hasTags(note)">
                        <v-chip
                          class="mr-2 mt-2"
                          small
                          color="secondary"
                          v-if="note.habit"
                        >
                          <v-icon left style="font-size:14px" class="pl-2">
                            fas fa-seedling</v-icon
                          >
                          {{ note.habit.name }}</v-chip
                        >
                        <v-chip
                          class="mr-2 mt-2"
                          small
                          color="primary"
                          v-if="note.goal"
                        >
                          <v-icon left style="font-size:14px" class="pl-2">
                            fas fa-flag-checkered</v-icon
                          >
                          {{ note.goal.name }}</v-chip
                        >
                        <v-chip
                          class="text-blue-info mr-2 mt-2"
                          small
                          color="#667eea"
                          outlined
                          v-if="note.isWeekWin"
                        >
                          <v-icon left style="font-size:14px">
                            fas fa-glass-cheers</v-icon
                          >

                          Week win</v-chip
                        >
                        <v-chip
                          class="text-blue-info mr-2 mt-2"
                          small
                          outlined
                          color="#667eea"
                          v-if="note.isWeekLoss"
                        >
                          <v-icon left style="font-size:14px">
                            far fa-frown</v-icon
                          >
                          Needs improve</v-chip
                        >
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col></v-row
              >
              <div class="text-center mt-8">
                <v-btn
                  color="primary"
                  class="text-none"
                  outlined
                  :block="$vuetify.breakpoint.smAndDown"
                  v-if="haveMore"
                  @click="loadMoreNotes()"
                >
                  Load more
                </v-btn>
                <p v-else>All notes loaded 😉</p>
              </div>
            </div>
            <div class=" mt-4" v-else>
              <p>You've not saved any notes yet 😕</p>
            </div>
          </div>
        </v-card>
      </v-col></v-row
    ></v-container
  >
</template>

<script>
import {mapGetters} from 'vuex'
import {format, toDate} from 'date-fns'

export default {
  data() {
    return {
      showNoti: false,
      noti: {
        color: 'primary',
        type: 'info',
        classes: 'text-purple',
        message: 'Note saved',
      },
      notesBatchesRetrieved: 0,
      notesPerBatch: 10,
      isLoading: false,
      noteSaved: false,
      haveMore: true,
      note: '',
      linkToGH: false,
      linkedGH: '',
      includeInWeek: false,
      inWeekAs: '',
      noteRules: [
        v => !!v || 'A note is required',
        v => (!!v && v.length > 30) || 'Note should be at least 30 characters',
        v =>
          (!!v && v.length < 1500) ||
          'Note should be less than 1500 characters',
      ],
      linkedGHRules: [v => (v && !!this.linkedGH) || 'Select a goal or habit'],
      winLossRules: [v => (v && !!this.includeInWeek) || 'Choose an option'],
    }
  },
  computed: {
    ...mapGetters([
      'userDetails',
      'weekData',
      'notesByDate',
      'wipGoals',
      'activeHabits',
    ]),
  },
  async mounted() {
    this.loadFontAwesomeCSS()
    this.loadFirstNotes()
  },
  methods: {
    checkGHSelected() {
      if (this.linkToGH && !!this.linkedGH) return 'Select a goal or habit'
      return true
    },
    isGoalOrHabit(id) {
      let result = {
        isGoal: false,
        isHabit: false,
      }
      this.wipGoals.forEach(goal => {
        if (goal.id == id) {
          result.isGoal = true
        }
      })
      this.activeHabits.forEach(habit => {
        if (habit.id == id) {
          result.isHabit = true
        }
      })
      return result
    },
    hasTags(note) {
      if (note.isWeekLoss || note.isWeekWin || note.habit || note.goal)
        return true
      return false
    },
    async loadFirstNotes() {
      try {
        const res = await this.$store.dispatch('getNotes', {
          limit: this.notesPerBatch,
          start: this.notesPerBatch * this.notesBatchesRetrieved,
        })
        this.notesBatchesRetrieved++
        if (res.length < this.notesPerBatch) {
          this.haveMore = false
        }
      } catch (error) {
        console.error(error)
        this.noti.message = 'There was an error retrieving your notes'
        this.noti.type = 'error'
        this.noti.classes = 'text-pink'
        this.noti.color = 'secondary'
        this.showNoti = true
      }
    },
    async loadMoreNotes() {
      try {
        const res = await this.$store.dispatch('getMoreNotes', {
          limit: this.notesPerBatch,
          start: this.notesPerBatch * this.notesBatchesRetrieved,
        })
        this.notesBatchesRetrieved++
        if (res.length == 0) {
          console.log('no more notes to load')
          this.haveMore = false
        }
      } catch (error) {
        console.error(error)
        this.noti.message = 'There was an error retrieving your notes'
        this.noti.type = 'error'
        this.noti.classes = 'text-pink'
        this.noti.color = 'secondary'
        this.showNoti = true
      }
    },
    async handleStore() {
      if (this.$refs.noteForm.validate()) {
        this.isLoading = true
        console.log('saving...')
        try {
          const ghRes = this.isGoalOrHabit(this.linkedGH)
          console.log('ghRes :>> ', ghRes)
          const newNote = {
            note: this.note,
            // stack: this.weekData.id,

            isWeekWin: this.includeInWeek && this.inWeekAs == 'week-win',
            isWeekLoss: this.includeInWeek && this.inWeekAs == 'week-loss',
          }
          if (ghRes.isGoal) newNote.goal = this.linkedGH
          if (ghRes.isHabit) newNote.habit = this.linkedGH

          if (newNote.isWeekWin || newNote.isWeekLoss)
            newNote.stack = this.weekData.id

          console.log('newNote :>> ', newNote)
          const res = await this.$store.dispatch('storeNote', newNote)
          console.log('res :>> ', res)
          this.isLoading = false
          //  Show a vuetify snackbar
          this.$store.dispatch('showSnackbar', {
            visibility: true,
            text: 'Personal note saved!',
            icon: 'fas fa-pen-nib',
            color: 'primary',
            textColor: '#ffffff',
            timeout: 4000,
          })
          // this.noti.message = 'Personal note saved 😊'
          // this.noti.type = 'info'
          // this.noti.classes = 'text-purple'
          // this.noti.color = 'primary'

          // this.showNoti = true
          this.$refs.noteForm.reset()
          // hide alert after 5 secs
          setTimeout(() => {
            this.showNoti = false
          }, 5000)
        } catch (error) {
          console.error(error)
          this.isLoading = false
          this.noti.message = 'There was an error saving this note'
          this.noti.type = 'error'
          this.noti.classes = 'text-pink'
          this.noti.color = 'secondary'
          this.showNoti = true
        }
      }
    },
    handleLoadMore() {},
    loadFontAwesomeCSS() {
      let file = document.createElement('link')
      file.rel = 'stylesheet'
      file.href = 'https://use.fontawesome.com/releases/v5.8.2/css/all.css'
      document.head.appendChild(file)
    },
    formatDate(date) {
      return format(toDate(new Date(date)), 'do LLL y hh :mm aaa')
    },
  },
  metaInfo: {
    title: 'Personal Notes',
    titleTemplate: '%s | theLIFEBOARD.app',
    link: [{rel: 'canonical', href: 'https://thelifeboard.app'}],
  },
}
</script>

<style></style>
